export default __webpack_public_path__ + "static/media/element_42.d8391d99.jpg";